import { render } from "./App.vue?vue&type=template&id=6d34b750"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/remotejenkins8/workspace/Gears_Docker_tar2/nexcor-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__